import { createAction } from '@reduxjs/toolkit'

import { SupportedGenericReducerPCRChannels } from '../types'
import { IPCRMetricsResponse, PCRMetricsActionTypes } from './types'

export const fetchPcrMetrics = createAction(
  PCRMetricsActionTypes.FETCH_REQUEST,
  (campaignId: number, pcrChannel: SupportedGenericReducerPCRChannels) => ({
    payload: { campaignId, pcrChannel },
  }),
)

export const fetchPcrMetricsSuccess = createAction(
  PCRMetricsActionTypes.FETCH_SUCCESS,
  (
    metrics: IPCRMetricsResponse,
    campaignId: number,
    pcrChannel: SupportedGenericReducerPCRChannels,
  ) => ({
    payload: {
      metrics,
      campaignId,
      pcrChannel,
    },
  }),
)

export const fetchPcrMetricsError = createAction(
  PCRMetricsActionTypes.FETCH_ERROR,
  (errors: any, campaignId: number, pcrChannel: SupportedGenericReducerPCRChannels) => ({
    payload: {
      errors,
      campaignId,
      pcrChannel,
    },
  }),
)
